import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs';

import { environment } from './../../../environments/environment';
import { ApiRequestService } from 'src/app/services/api-request/api-request.service';

@Injectable({
    providedIn: 'root'
  })
  export class PanelListService {
    // appurl = environment.apiUrl + '/v2/api';
    // GET_STUDYVISIBILITY = environment.apiUrl + '/v2/api/getStudyVisibility';
    // GET_PANELDETAILS = environment.apiUrl + '/v2/api/panel/';
    // GET_PSNEL_IPSOS = environment.apiUrl + '/v2/api/panelIpsos/';
    // GET_RESPONCE_DATA_QUOTA = environment.apiUrl + '/v2/api/survey/responseDateQuota';
    // GET_CITY_LIST = environment.apiUrl + '/v2/api/cityListIpsos/';
    // GET_DUPLICATE = environment.apiUrl + '/v2/api/getOriginalImageData/';
    // UPDATE_RESPONDENT = environment.apiUrl + '/v2/api/updateRespondent/';
    // LIST_IMG = environment.apiUrl + '/v2/api/panel/itc/responses';

    appurl = '/v2/api';
    GET_STUDYVISIBILITY = '/v2/api/getStudyVisibility';
    GET_PANELDETAILS = '/v2/api/panel';
    GET_PSNEL_IPSOS = '/v2/api/panelIpsos';
    GET_RESPONCE_DATA_QUOTA = '/v2/api/survey/responseDateQuota';
    GET_CITY_LIST = '/v2/api/cityListIpsos';
    GET_DUPLICATE = '/v2/api/getOriginalImageData';
    UPDATE_RESPONDENT = '/v2/api/updateRespondent';
    LIST_IMG = '/v2/api/panel/itc/responses';
    GET_USER_FOR_SCHEDULE = '/v2/study/getUser';


    studyInfo: any;
    // access = JSON.parse(localStorage.getItem('access'));
    httpPostOptions = {
        headers: new HttpHeaders().set('Content-Type', 'application/json'),
        withCredentials: true
      };

    private apiRequestHttpOptions:any = {
      httpOptions:this.httpPostOptions
    };
  
    constructor(private http: HttpClient, private apiRequest: ApiRequestService) { }

    getStudyVisiblity(studtId: string): Observable<any>{
          this.studyInfo = {study_id: studtId};
          return this.apiRequest.request('POST',this.GET_STUDYVISIBILITY,this.studyInfo,this.apiRequestHttpOptions);
        // return this.http.post<any>(this.GET_STUDYVISIBILITY, this.studyInfo, this.httpPostOptions);
    }

    getPanelDetails(studyId: string, page_no: number, limit:number): Observable<any>{
          this.studyInfo = {page_no: page_no, limit: limit};
          let pathUrl = this.GET_PANELDETAILS +'/'+ studyId
          return this.apiRequest.request('POST',pathUrl,this.studyInfo,this.apiRequestHttpOptions);
        // return this.http.post<any>(this.GET_PANELDETAILS + studyId, this.studyInfo, this.httpPostOptions);
    }

    getPanelIpsos(studyId: string, filterOptionCity: any, filterOptionStatus: any): Observable<any>{
          this.studyInfo = {filterOptionCity: filterOptionCity, filterOptionStatus: filterOptionStatus};
          let pathUrl = this.GET_PSNEL_IPSOS +'/'+ studyId
          return this.apiRequest.request('POST',pathUrl,this.studyInfo,this.apiRequestHttpOptions);
        // return this.http.post<any>(this.GET_PSNEL_IPSOS + studyId, this.studyInfo, this.httpPostOptions);
    }
    getResponceDataQuota(studyId: string): Observable<any>{
          this.studyInfo = {survey_id: studyId};
          return this.apiRequest.request('POST',this.GET_RESPONCE_DATA_QUOTA,this.studyInfo,this.apiRequestHttpOptions);
        // return this.http.post<any>(this.GET_RESPONCE_DATA_QUOTA, this.studyInfo, this.httpPostOptions);
    }
    getCityList(studyId: string): Observable<any>{
      let pathUrl = this.GET_CITY_LIST +'/'+ studyId
      return this.apiRequest.request('GET',pathUrl,{},this.apiRequestHttpOptions);
      // return this.http.get<any>(this.GET_CITY_LIST + studyId, this.httpPostOptions);
    }
    updateRespondent(id: number, state, studyId: string): Observable<any>{
      this.studyInfo = {id: id, state: state};
      let pathUrl = this.UPDATE_RESPONDENT +'/'+ studyId
      return this.apiRequest.request('POST',pathUrl,this.studyInfo,this.apiRequestHttpOptions);
      // return this.http.post<any>(this.UPDATE_RESPONDENT + studyId, this.studyInfo, this.httpPostOptions);
    }
    getDuplicate(details:any): Observable<any>{
      return this.apiRequest.request('POST',this.GET_DUPLICATE,details,this.apiRequestHttpOptions);
      // return this.http.post<any>(this.GET_DUPLICATE, details, this.httpPostOptions);
    }
    getImages(id:any): Observable<any>{
      let showImg = {userId: id};
      return this.apiRequest.request('POST',this.LIST_IMG,showImg,this.apiRequestHttpOptions);
      // return this.http.post<any>(this.LIST_IMG, showImg, this.httpPostOptions);
    }

    getEmailUserForSchedule(studyId: string): Observable<any>{
      let pathUrl = this.GET_USER_FOR_SCHEDULE + '/' + studyId
      return this.apiRequest.request('GET',pathUrl,{},this.apiRequestHttpOptions);
    }
}  